import { render } from "./features-style-one.vue?vue&type=template&id=28b6ee96"
import script from "./features-style-one.vue?vue&type=script&lang=js"
export * from "./features-style-one.vue?vue&type=script&lang=js"

import "./features-style-one.vue?vue&type=style&index=0&id=28b6ee96&lang=css"

import exportComponent from "/Applications/phpstudy/bjhy/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__